// Central mapping: cannabis product category → Phosphor line icon + colour.
import {
  Flower,
  Fire,
  Lightning,
  Cookie,
  Drop,
  Flask,
  Gear,
  Package,
} from "@phosphor-icons/react";

export const CATEGORY_META = {
  flower: { icon: Flower, colour: "var(--red)", label: "Flower" },
  "pre-rolls": { icon: Fire, colour: "var(--yellow)", label: "Pre-rolls" },
  vapes: { icon: Lightning, colour: "var(--blue)", label: "Vapes" },
  edibles: { icon: Cookie, colour: "var(--pink)", label: "Edibles" },
  concentrates: { icon: Drop, colour: "var(--green)", label: "Concentrates" },
  topicals: { icon: Flask, colour: "var(--blue-light)", label: "Tinctures" },
  accessories: { icon: Gear, colour: "var(--text)", label: "Accessories" },
};

export function iconFor(category) {
  return (CATEGORY_META[category] || { icon: Package, colour: "var(--text)" });
}

// Soft-tinted retro background per category — cream base + coloured wash.
export function tintFor(category) {
  const m = CATEGORY_META[category];
  const c = m?.colour || "var(--text)";
  return {
    background: `radial-gradient(circle at 30% 30%, ${c}22 0%, transparent 60%), #FFF9E6`,
  };
}
